export const PINK = '#e40079';
export const SKY_BLUE = '#0190f0';
export const WHITE = '#FFF';
export const BREADCRUMB = '#f0f7f9';
export const BLACK = '#1a1917';
export const F_BLACK = '#2e2b2b'
export const F_BORDER = '#cfcfcf';
